import { render, staticRenderFns } from "./AiDrawer.vue?vue&type=template&id=87fed78a&scoped=true&"
import script from "./AiDrawer.vue?vue&type=script&lang=js&"
export * from "./AiDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AiDrawer.vue?vue&type=style&index=0&id=87fed78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fed78a",
  null
  
)

export default component.exports